import { render, staticRenderFns } from "./CourseRegisters.vue?vue&type=template&id=7416bc3a&scoped=true&"
import script from "./CourseRegisters.vue?vue&type=script&lang=js&"
export * from "./CourseRegisters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7416bc3a",
  null
  
)

export default component.exports